export default "/_next/static/images/7b81b64f6e331c5ae08427329fec1347.svg";